import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CellTowerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cell_tower"}/>
}
